import { FC } from 'react';
import styles from './ToggleSwitch.module.css';

interface ToggleSwitchProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const ToggleSwitch: FC<ToggleSwitchProps> = ({ label, checked, onChange, disabled = false }) => {
  return (
    <label className={`${styles.container} ${disabled ? styles.disabled : ''}`}>
      <input
        type="checkbox"
        className={styles.input}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      <span className={`${styles.slider} ${checked ? styles.sliderOn : ''}`}>
        <span className={styles.thumb} />
      </span>
      <span className="body-sm-regular">{label}</span>
    </label>
  );
};

export default ToggleSwitch;
